/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Hide the pre hide varient

window.onload = function() {
    var element = document.querySelector('.click_size_varient');
    if (element) {
        // Class found, run the function
        document.querySelectorAll('.Pre_hide_primary_button').forEach(function(element) {
         element.style.display = 'none';
        });
    } else {
        // Class not found, you can optionally handle this case
        document.querySelectorAll('.Pre_hide_primary_button').forEach(function(element) {
         element.style.display = 'block';
        });
        document.querySelectorAll('.post_hide_button').forEach(function(element) {
         element.style.display = 'none';
        });
    }
};

// Add a click event listener to the document
document.addEventListener('click', function(event) {
    // Check if the clicked element has the class 'click_size_varient'
    if (event.target.classList.contains('click_size_varient')) {
        // Set the text of elements with class 'click_size_varient' to "Select A Width"
        var width_element = document.querySelector('.click_width_varient ');
        if(width_element){
          document.querySelectorAll('.click_width_varient').forEach(function(element) {
             element.classList.add('width_varient_label');
          });
          document.querySelectorAll('.post_hide_button').forEach(function(element) {
              element.innerText = "Select a width";
          });
        // Check if the clicked element also has the class 'click_width_varient'  
        }else{
          document.querySelectorAll('.Pre_hide_primary_button').forEach(function(element) {
           element.style.display = 'block';
          });
          document.querySelectorAll('.post_hide_button').forEach(function(element) {
           element.style.display = 'none';
          });
        }       
    }
    // first step in code to find the varient
    if (event.target.classList.contains('size_varient_label')) {
            // Show elements with class 'Pre_hide_primary_button'
            document.querySelectorAll('.Pre_hide_primary_button').forEach(function(element_cta_pre) {
                element_cta_pre.style.display = 'block';
            });
            // Hide elements with class 'post_hide_button'
            document.querySelectorAll('.post_hide_button').forEach(function(element_cta_post) {
            element_cta_post.style.display = 'none';
      });
     }
    if (event.target.classList.contains('width_varient_label')) {
            // Show elements with class 'Pre_hide_primary_button'
            document.querySelectorAll('.Pre_hide_primary_button').forEach(function(element_cta_pre) {
                element_cta_pre.style.display = 'block';
            });
            // Hide elements with class 'post_hide_button'
            document.querySelectorAll('.post_hide_button').forEach(function(element_cta_post) {
            element_cta_post.style.display = 'none';
      });
     }
     if (event.target.classList.contains('click_width_varient')) {
            // Show elements with class 'Pre_hide_primary_button'        
            document.querySelectorAll('.click_size_varient').forEach(function(element) {
               element.classList.add('size_varient_label');
            });
            document.querySelectorAll('.post_hide_button').forEach(function(element) {
               element.innerText = "Select a size";
            });

            // // Show elements with class 'pre_hide_button'
            // document.querySelectorAll('.Pre_hide_primary_button').forEach(function(element_cta_pre) {
            //     element_cta_pre.style.display = 'block';
            // });
            // // Hide elements with class 'post_hide_button'
            // document.querySelectorAll('.post_hide_button').forEach(function(element_cta_post) {
            // element_cta_post.style.display = 'none';
            //}
    }
});

// short code
// document.querySelectorAll('.Pre_hide_primary_button').forEach(element => element.style.display = 'none');
// document.addEventListener('click', event => {
//     if (event.target.classList.contains('click_size_varient')) {
//         document.querySelectorAll('.click_width_varient').forEach(element => element.classList.add('width_varient_label'));
//         document.querySelectorAll('.post_hide_button').forEach(element => element.innerText = "Select a width");
//     } else if (event.target.classList.contains('size_varient_label') || event.target.classList.contains('width_varient_label')) {
//         document.querySelectorAll('.Pre_hide_primary_button').forEach(element => element.style.display = 'block');
//         document.querySelectorAll('.post_hide_button').forEach(element => element.style.display = 'none');
//     } else if (event.target.classList.contains('click_width_varient')) {
//         document.querySelectorAll('.click_size_varient').forEach(element => {
//             element.classList.add('size_varient_label');
//         });
//         document.querySelectorAll('.post_hide_button').forEach(element => element.innerText = "Select a Size");
//     }
// });


